import { apiLabs } from '../../api'

const findOneEggShellOrder = async (pedido) => {
	const res = await apiLabs.get(`separa/painel_cascas/find/${pedido}`)
	return res
}

export default findOneEggShellOrder
